module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "address-box"
  }, [_vm._m(0), _vm._v(" "), (_vm.mapAddr != null && _vm.mapAddr != '' && _vm.mapAddr != undefined) ? _c('h3', [_vm._v(_vm._s(_vm.mapAddr))]) : _vm._e()]), _vm._v(" "), (_vm.mapPic != null && _vm.mapPic != '' && _vm.mapPic != undefined) ? _c('img', {
    staticClass: "pic",
    attrs: {
      "src": _vm.mapPic
    }
  }) : _c('div', {
    staticClass: "no-pic"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v("自提地点")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3991056e","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Map.vue
// module id = 427
// module chunks = 7